<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="0" >歡迎光臨，是臺灣文學館的館員吧？</npc>
              <npc :npc-id="2" right>是的，之前我有打電話過來——</npc>
              <npc :npc-id="0" >請坐，我們就速速進入正題吧。</npc>
              <npc :npc-id="2" right>好。是這樣的，昨天晚上，我們館裡遭了小偷——</npc>
              <npc :npc-id="1" >小偷！？臺灣文學館？</npc>
              <npc :npc-id="0" >臺灣文學館應該算是戒備森嚴吧？</npc>
              <npc :npc-id="2" right>當然啦，畢竟很多重要藏品與展品，所以我們也不懂小偷是怎麼進來的。事實上，當時文學館的門窗都關了，卻還是被那個小偷逃走，真是奇怪！</npc>
              <npc :npc-id="0" >我明白了。是什麼被偷了？</npc>
              <npc :npc-id="2" right>是，其實被偷的是這個——</npc>
              <story-image :src="require(`@/assets/images/pics/第1章_2-1_賴和面具.png`)"></story-image>
              <!-- （圖片：賴和面具的照片） -->
              <npc :npc-id="1" >哇！好恐怖的面具啊！</npc>
              <npc :npc-id="0" >這⋯⋯難道是賴和石膏面具？</npc>
              <npc :npc-id="1" >石膏面具？難道是『死亡面具』嗎？據說以前西方人死去的時候會用石膏為死者製作面具——</npc>
              <npc :npc-id="0" >不，這只是崇拜賴和的研究人員依照照片自行製作的面具，退休後交給了文學館啦。</npc>
              <npc :npc-id="1" >欸！？也就是雖然頂著賴和的名義，但其實跟賴和毫無關係的物件嗎？</npc>
              <npc :npc-id="2" right>哈哈哈，無法否認呢。</npc>
              <npc :npc-id="0" >這就奇怪了⋯⋯</npc>
              <npc :npc-id="2" right>怎麼了？</npc>
              <npc :npc-id="0" >失竊的只有這個吧？文學館裡珍貴的典藏這麼多，結果卻偷了這個其實跟賴和無關的面具，到底——</npc>
              <npc :npc-id="2" right>我們也不明白，而且犯人顯然是針對賴和而來的。</npc>
              <npc :npc-id="0" >怎麼說？</npc>
              <npc :npc-id="2" right>其實犯人還留下這個。</npc>
              <story-image :src="require(`@/assets/images/pics/第1章_2-2_名片與簽名.jpg`)" size="sm"></story-image>
              <!-- （圖片：寫著怪盜懶雲與簽名的名片） -->
              <story-image :src="require(`@/assets/images/pics/第1章_2-3_小逸堂合照.jpg`)" size="lg"></story-image>
              <!-- （圖片：賴和跟同學在小逸堂前面拍的照片） -->
              <npc :npc-id="0" >怪、怪盜懶雲！？</npc>
              <npc :npc-id="1" >懶雲？那不是賴和的號嗎？</npc>
              <npc :npc-id="0" >開什麼玩笑！竟敢自稱怪盜賴和，太冒瀆了！</npc>
              <npc :npc-id="1" >有到冒瀆這麼誇張嗎？話說回來，這個簽名是什麼？</npc>
              <story-image :src="require(`@/assets/images/pics/第1章_2-4_名片與簽名.jpg`)"></story-image>
              <!-- （圖片：放大簽名的部分） -->
              <npc :npc-id="2" right>這個我們研究組的組員也試圖破解，但沒有結論。</npc>
              <npc :npc-id="0" >相當花俏的簽名呢，應該是某種符號遊戲⋯⋯</npc>
              <npc :npc-id="0" >先不管這個。這張照片是？</npc>
              <npc :npc-id="2" right>這是賴和先生跟他的朋友在小逸堂前拍的照片，但重點是照片背後寫的文字。</npc>
              <npc :npc-id="0" >『無可取代的回憶，我收下了』⋯⋯？</npc>
              <npc :npc-id="2" right>我們也不明白是什麼意思，但我猜這是暗示怪盜懶雲下一個要偷的東西——就像亞森・羅蘋的預告信。</npc>
              <npc :npc-id="0" >原來如此，所以才自稱怪盜嗎？怪盜要偷的東西在小逸堂⋯⋯是這麼回事嗎？</npc>
              <npc :npc-id="2" right>是的。呂偵探，我們文學館想委託的，是請你抓到自稱懶雲的怪盜，把賴和石膏面具給帶回來。</npc>
              <npc :npc-id="0" >好，我接受。</npc>
              <npc :npc-id="1" >呀呼！總算有工作了，我們要去哪？</npc>
              <npc :npc-id="0" >剛剛不就說了嗎？聽好了，攔截怪盜的第一站，就是彰化的小逸堂。</npc>

              <map-link name="南山寺" map-id="J2sn8tRt1GaMzT636"/>

              <move-to-stage-btn link="前往小逸堂">前往小逸堂</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage1_2',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第一章 - 2',
      isQuestion: false,
      stageId: 'meeting',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
